import React from "react";
import { Card, Avatar, Dropdown, Image } from "antd";
import { App } from "context/AppContext";
import { DownOutlined } from "@ant-design/icons";
import ProfileMenu from "./ProfileMenu";
import noProfile from "assets/images/no_profile.jpg";

const NavBar = () => {
  const { collapsed, userData } = App();
  let username = "";

  if (userData?.UserName?.length > 0) {
    if (userData?.UserName?.length > 16) {
      username = userData?.UserName.substring(0, 16).concat("...");
    } else {
      username = userData?.UserName.substring(0, 16);
    }
  }

  return (
    <Card style={{ backgroundColor: "#001529", border: "1px solid transparent" }}>
      <Dropdown overlay={<ProfileMenu />} trigger={["click"]}>
        <span
          style={{
            userSelect: "none",
            cursor: "pointer",
            height: "100%",
            width: "100%",
            display: "inline-block",
            padding: "0",
          }}
        >
          <Avatar
            shape="circle"
            icon={<Image preview={false} alt="" src={noProfile} height={30} width={30} />}
            style={{ marginRight: 5 }}
          />
          {!collapsed && (
            <span
              style={{
                fontWeight: "500",
                color: "#fff",
              }}
            >
              {username}
            </span>
          )}
          <DownOutlined
            style={{
              color: "#fff",
              marginLeft: collapsed ? "10px" : "5px",
              fontSize: "10px",
            }}
          />
        </span>
      </Dropdown>
    </Card>
  );
};

export default NavBar;
